export default __webpack_public_path__ + "images/4b5469eae64e8de8fbb7aa297dc77870.png";